import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

interface Props { buckets: number[] } // [0-30,31-60,61-90,90+]

// Sedra tints for harmonious palette
const PIE_COLORS = ['#4a274f', '#7d4d86', '#b18cc0', '#dbc6e3'];

export const AgingPie: React.FC<Props> = ({ buckets }) => {
  const data = {
    labels: ['0-30','31-60','61-90','90+'],
    datasets: [{ 
      data: buckets, 
      backgroundColor: PIE_COLORS, 
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };
  const opts = {
    responsive: true,
    plugins: {
      tooltip:{ callbacks:{ label:(ctx:any)=>`${ctx.label}: $${ctx.parsed.toLocaleString()} (${ctx.formattedValue}%)` } },
      legend:{ position: 'right' as const, labels:{ boxWidth:12, color: '#374151' } },
    },
  };
  return <Pie aria-label="A/R aging pie chart" data={data} options={opts} />;
}; 